import React from "react";

import { 
    Box, 
    Button, 
    FormControl, 
    Grid, 
    IconButton, 
    Typography, 
} from "@mui/material";

import { Trans } from "@lingui/macro";

import { ThumbUploadProps } from "./models";

import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ClearIcon from "@mui/icons-material/Clear";


export class ThumbUpload extends React.Component<ThumbUploadProps, {}> {

  render(){
    return(<>
        <FormControl>
            {!this.props.isThumbUploaded && <Button
                component="label"
                sx={{
                    border: "1px dashed #E9E9E9",
                    background: `linear-gradient(279.75deg, #3E0449 -2.65%, #E50146 84.59%)`,
                    boxShadow: `0px 2px 7px 4px rgba(137, 1, 42, 0.25)`
                }}
                fullWidth>
                <Grid container m={4}>
                    <Grid item xs={12} textAlign="center">
                        <AddPhotoAlternateIcon fontSize="large" sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}/>
                    </Grid>
                    <Grid item xs={12} textAlign="center">
                        <Typography variant="caption" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                            <Trans id={"df-upload-thumb-msg"}>Carica anteprima</Trans>
                        </Typography>
                    </Grid>
                </Grid>
                <input hidden accept="pdf/*" multiple type="file" onChange={this.props.parseFileImg}/>
            </Button>}
            {this.props.isThumbUploaded && <Box>
                <img src={this.props.fileImgURL} width={250} alt={"FileImg"} />
                <br/>
                <Typography variant="caption" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    {this.props.fileImgName}
                </Typography>
                <IconButton onClick={this.props.removeFileImg}>
                    <ClearIcon fontSize={"small"} sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}} />
                </IconButton>
            </Box>}
        </FormControl>
    </>)
  }
}